import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import { Modal } from "react-bootstrap";
import Button from "../../../../components/Button";
import BackButton from "../../../../components/BackButton";
import { useAuth } from "../../../../context/AuthContext";
 
const EditShippingForm = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [enquiry, setEnquiry] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showEditConfirm, setShowEditConfirm] = useState(false);
  const navigate = useNavigate();
 
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        setEnquiry(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchEnquiry();
  }, [id]);
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    // Navigate based on user role
    if (user?.user_role === 'Admin' || user?.user_role === 'SuperAdmin') {
      navigate("/list-of-bl/admin");
    } else if (user?.user_role === 'sales_rep') {
      navigate("/freight-enquiries");
    } else {
      navigate("/my-bookings/list-of-bl");
    }
  };

  const handleConfirmEdit = () => {
    setShowEditConfirm(false);
    formik.handleSubmit();
  };
 
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: enquiry || {
      first_shipper_name: "",
      first_shipper_address: "",
      second_shipper_name: "",
      second_shipper_address: "",
      first_consignee_name: "",
      first_consignee_address: "",
      second_consignee_name: "",
      second_consignee_address: "",
      notify_party_1: "",
      notify_party_1_address: "",
      notify_party_2: "",
      notify_party_2_address: "",
      commercial_invoice_number: "",
      commercial_invoice_date: "",
      marks_and_packages: "",
      net_weight: "",
      iec_number: "",
      gross_weight: "",
      General_Remarks: "",
      Status: "",
      Status_client: "",
    },
    onSubmit: async () => {
      setLoadingSubmit(true);
      try {
        const payload = {
          ...formik.values,
          enq_id: id,
          net_weight: parseFloat(formik.values.net_weight),
          gross_weight: parseFloat(formik.values.gross_weight),
          notificationType: "shared",
        };
        await api.put(`/si/updateShippingInstruction`, payload);
        setShowSuccess(true);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingSubmit(false);
      }
    },
  });
 
  if (!enquiry) return <div>Loading...</div>;
 
  return (
    <>
       <BackButton />
      <form onSubmit={formik.handleSubmit}>
        <div className="row py-4">
          {/* All fields from Create form */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipper Name"
              name="first_shipper_name"
              placeholder="Enter the first Shipper Name"
              value={formik.values.first_shipper_name}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipper Address"
              name="first_shipper_address"
              placeholder="Enter the Shipper Address"
              value={formik.values.first_shipper_address}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Consignee Name"
              name="first_consignee_name"
              placeholder="Enter the Consignee Name"
              value={formik.values.first_consignee_name}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Consignee Address"
              name="first_consignee_address"
              placeholder="Enter the Consignee Address"
              value={formik.values.first_consignee_address}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 1"
              name="notify_party_1"
              placeholder="Enter the Notify Party 1"
              value={formik.values.notify_party_1}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 1 Address"
              name="notify_party_1_address"
              placeholder="Enter the Notify Party 1 Address"
              value={formik.values.notify_party_1_address}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 2"
              name="notify_party_2"
              placeholder="Enter the Notify Party 2"
              value={formik.values.notify_party_2}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 2 Address"
              name="notify_party_2_address"
              placeholder="Enter the Notify Party 2 Address"
              value={formik.values.notify_party_2_address}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Commercial Invoice Number"
              name="commercial_invoice_number"
              placeholder="Enter the Commercial Invoice Number"
              value={formik.values.commercial_invoice_number}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Commercial Invoice Date"
              name="commercial_invoice_date"
              type="date"
              placeholder="Enter the Commercial Invoice Date"
              value={formik.values.commercial_invoice_date}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Marks and Number of Packages"
              name="marks_and_packages"
              placeholder="Enter the Marks and Number of Packages"
              value={formik.values.marks_and_packages}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Net Weight"
              type="number"
              name="net_weight"
              placeholder="Enter the Net Weight"
              value={formik.values.net_weight}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="I.E.C Number"
              name="iec_number"
              placeholder="Enter the I.E.C. Number"
              value={formik.values.iec_number}
              onChange={formik.handleChange}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Gross Weight"
              type="number"
              name="gross_weight"
              placeholder="Enter the Gross Weight"
              value={formik.values.gross_weight}
              onChange={formik.handleChange}
            />
          </div>
 
          {/* Second BL fields if Switch BL */}
          {enquiry?.switch_bl === "Yes" && (
            <>
              <p>Please fill the shipping instructions for BL2</p>
              <div className="row py-4">
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipper Name"
                    name="second_shipper_name"
                    placeholder="Enter the Shipper Name"
                    value={formik.values.second_shipper_name}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipper Address"
                    name="second_shipper_address"
                    placeholder="Enter the Shipper Address"
                    value={formik.values.second_shipper_address}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Consignee Name"
                    name="second_consignee_name"
                    placeholder="Enter the Consignee Name"
                    value={formik.values.second_consignee_name}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Consignee Address"
                    name="second_consignee_address"
                    placeholder="Enter the Consignee Address"
                    value={formik.values.second_consignee_address}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
            </>
          )}
 
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Remarks"
              name="General_Remarks"
              placeholder="Enter any additional information"
              value={formik.values.General_Remarks}
              onChange={formik.handleChange}
            />
          </div>
        </div>
 
        <div className="d-flex justify-content-end mt-3">
          <button type="button" className="btn btn-primary" onClick={() => setShowEditConfirm(true)} disabled={loadingSubmit}>
            {loadingSubmit ? "Updating..." : "Update Shipping Instructions"}
          </button>
        </div>
      </form>

      {/* Edit Confirmation Modal */}
      <Modal show={showEditConfirm} onHide={() => setShowEditConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Edit Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You can make only 1 edit request. Are you sure you want to proceed?
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowEditConfirm(false)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleConfirmEdit}>
            Proceed
          </button>
        </Modal.Footer>
      </Modal>
 
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Shipping Instructions updated successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
 
export default EditShippingForm;
 
 